import { NgModule } from "@angular/core";
import { AuthServiceProxy, CountryServiceProxy, CustomerNoteServiceProxy, CustomerServiceProxy, CustomerStatusServiceProxy, OrderServiceProxy, ProductServiceProxy, SalesStatisticsServiceProxy, StatisticsServiceProxy, SubscriptionServiceProxy, UserServiceProxy } from "./event-service-proxy";

@NgModule({
    providers: [
        AuthServiceProxy,
        CustomerServiceProxy,
        CustomerStatusServiceProxy,
        OrderServiceProxy,
        SubscriptionServiceProxy,
        ProductServiceProxy,
        CustomerNoteServiceProxy,
        SalesStatisticsServiceProxy,
        StatisticsServiceProxy,
        UserServiceProxy,
        StatisticsServiceProxy,
        CountryServiceProxy
    ],
})
export class ServiceProxyModule { }